import BaseService from "./BaseService";

export type TicketStatus = 'new' | 'open' | 'pending' | 'hold' | 'solved' | 'closed';

export interface ISupportTicket {
    id: number;
    subject: string;
    description: string;
    status: TicketStatus;
    priority?: string | null;
    createdAt: string;
    updatedAt: string;
    requester?: { id: number; name: string; email: string };
}

export interface ITicketMessage {
    id: number;
    author: 'customer' | 'support';
    authorName: string;
    body: string;
    isPublic: boolean;
    createdAt: string;
}

export interface ISupportTicketDetail extends ISupportTicket {
    conversation: ITicketMessage[];
}

export interface ISupportTicketList {
    tickets: ISupportTicket[];
    total: number;
    page: number;
    perPage: number;
    hasMore: boolean;
}

const headers = (token: string) => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': "Bearer " + token
});

/**
 * Admin support-ticket API (Zendesk, via the backend — Zendesk credentials never reach the
 * browser). noError_ is set so callers can show the API's own message (e.g. "This reply was
 * already submitted.") instead of BaseService's generic alert.
 */
export default class SupportTicketServices extends BaseService {
    public static getTickets(token: string, params: { page: number; perPage: number; status?: string; search?: string }) {
        const query = new URLSearchParams({ page: String(params.page), perPage: String(params.perPage) });
        if (params.status) query.set('status', params.status);
        if (params.search) query.set('search', params.search);

        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `zendesk/admin/tickets?${query.toString()}`, {
            method: 'get',
            headers: headers(token)
        }, undefined, false, true);
    }

    public static getTicket(token: string, ticketId: number) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `zendesk/admin/tickets/${ticketId}`, {
            method: 'get',
            headers: headers(token)
        }, undefined, false, true);
    }

    public static reply(token: string, ticketId: number, message: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `zendesk/admin/tickets/${ticketId}/reply`, {
            method: 'post',
            headers: headers(token),
            body: JSON.stringify({ message })
        }, undefined, false, true);
    }

    public static updateStatus(token: string, ticketId: number, status: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `zendesk/admin/tickets/${ticketId}/status`, {
            method: 'PATCH',
            headers: headers(token),
            body: JSON.stringify({ status })
        }, undefined, false, true);
    }
}
